import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants/api';

const API = `${API_URL}/api`;

const ResetPasswordForm = ({ token, onSuccess }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API}/auth/reset-password`, {
        reset_token: token,
        new_password: newPassword,
      });
      setMessage(response.data.message);
      setTimeout(() => onSuccess(), 2000);
    } catch (err) {
      let msg = 'Failed to reset password';
      if (err.response?.data?.detail) msg = err.response.data.detail;
      else if (Array.isArray(err.response?.data) && err.response.data.length > 0)
        msg = err.response.data[0]?.msg || msg;
      else if (typeof err.response?.data === 'string') msg = err.response.data;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full space-y-6 sm:space-y-8 p-5 sm:p-8 card-calming" style={{ maxWidth: '28rem' }}>
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-primary-text heading-calming mb-2">Set New Password</h2>
          <p className="text-calming">Enter and confirm your new password</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {error && (
            <div className="bg-red-900/50 border border-red-500 text-red-200 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          {message && (
            <div className="bg-green-900/50 border border-green-500 text-green-200 px-4 py-3 rounded-lg">
              {message}
              <div className="text-sm mt-1">Redirecting to sign in...</div>
            </div>
          )}

          <div>
            <input
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full input-calming"
              required
              minLength="8"
              autoComplete="new-password"
            />
          </div>

          <div>
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full input-calming"
              required
              minLength="8"
              autoComplete="new-password"
            />
          </div>

          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            Password must be at least 8 characters. A short phrase works great.
          </p>

          <button
            type="submit"
            disabled={loading || !!message}
            className="w-full btn-calming-primary"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <div className="text-center">
          <button
            onClick={onSuccess}
            className="text-calming hover:text-gentle-gold text-sm transition-colors"
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
